import { NgModule, FactoryProvider } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoaderComponent } from './loader/loader.component';
import { DefaultLayoutComponent } from '../container/default-layout/default-layout.component';
import { NotificationComponent } from './notification/notification.component';
import { ToasterModule, ToasterService } from 'angular2-toaster';
import { RouterModule } from '@angular/router';
import {AppAsideModule, AppBreadcrumbModule, AppFooterModule, AppHeaderModule} from '@coreui/angular';
import {PerfectScrollbarModule} from 'ngx-perfect-scrollbar';
import {DataTablesModule} from 'angular-datatables';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {HttpClientModule} from '@angular/common/http';
import {SelectModule} from 'ng-select';
import {AngularMultiSelectModule} from './lib/angular2-multiselect-dropdown-lib/src/lib';
import {BsDatepickerModule, DatepickerModule, BsDatepickerConfig} from 'ngx-bootstrap/datepicker';
import {TypeaheadModule} from 'ngx-bootstrap/typeahead';
import {BsDropdownModule} from 'ngx-bootstrap/dropdown';
import {ModalModule, BsModalService, BsModalRef} from 'ngx-bootstrap/modal';
import {TabsModule} from 'ngx-bootstrap/tabs';
import {TooltipModule} from 'ngx-bootstrap/tooltip';
import { HttpCustomService } from 'src/service/http-custom.service';
import './rxjs-operators';
import { BodyContentComponent } from './compoment/body-content/body-content.component';
import { TableCommonComponent } from './compoment/table-common/table-common.component';
import { ActionBarComponent } from './compoment/action-bar/action-bar.component';
import { ActionBarService } from './service/action-bar.service';
import { TabBarService } from './service/tab-bar.service';
import { CustomActionEvent } from './compoment/action-bar/service/custom-action-event';
import { BodyFilterComponent } from './compoment/body-filter/body-filter.component';
import { InputSearchComponent } from './compoment/input-search/input-search.component';
import { BodyHeaderComponent } from './compoment/body-header/body-header.component';
import { BoxDataComponent } from './compoment/box-data/box-data.component';
import { InputTextComponent } from './compoment/input-text/input-text.component';
import { SelectComponent } from './compoment/select/select.component';
import { DatePickerComponent } from './compoment/date-picker/date-picker.component';
import { BodyContentListComponent } from './compoment/body-content-list/body-content-list.component';
import { ActionBarContext } from './compoment/action-bar/strategy/action-bar-context';
import { ActionBarBehavior } from './compoment/action-bar/strategy/action-bar-behavior';
import { RefreshActionBarBehavior } from './compoment/action-bar/strategy/impl/refresh-action-bar-behavior';
import { HeaderInfoComponent } from './compoment/header-info/header-info.component';
import { StatusPipe } from './pipe/status.pipe';
import { ConvertStatusCodeService } from './service/convert-status-code.service';
import { TabBarComponent } from './compoment/tab-bar/tab-bar.component';
import { CustomerResolver } from './resolver/customer-resolver';
import { CloseActionBarBehavior } from './compoment/action-bar/strategy/impl/close-action-bar-behavior';
import { ErrorPipe } from './pipe/error.pipe';
import { ChartCommonComponent } from './compoment/chart-common/chart-common.component';
import { ChartsModule } from 'ng2-charts';
import { AddNewFormComponent } from './compoment/add-new-form/add-new-form.component';
import { ConfirmationDialogComponent } from './compoment/confirmation-dialog/confirmation-dialog.component';
import { NewActionBarBehavior } from './compoment/action-bar/strategy/impl/new-action-bar-behavior';
import { DeleteActionBarBehavior } from './compoment/action-bar/strategy/impl/delete-action-bar-behavior';
import { SaveActionBarBehavior } from './compoment/action-bar/strategy/impl/save-action-bar-behavior';
import { AccordionComponent } from './compoment/accordion/accordion.component';
import { TextAutoCompleteComponent } from './compoment/text-auto-complete/text-auto-complete.component';
import { AppSidebarModule } from 'src/sidebar';
import {AdminGuard} from "../service/admin-guard";
import {CooperativeGuard} from "../service/cooperative-guard.service";
import { ImportCustomerComponent } from './compoment/import-customer/import-customer.component';
import {ImportCustomerActionBarBehavior} from "./compoment/action-bar/strategy/impl/import-customer-action-bar-behavior";
import {ExportMeterDataBehavior} from "./compoment/action-bar/strategy/impl/export-meter-data-behavior";
import {NavDataService} from "./service/nav-data.service";
import {ReportActionBarBehavior} from "./compoment/action-bar/strategy/impl/report-action-bar-behavior";
import { ImportCooperativeComponent } from './compoment/import-cooperative/import-cooperative.component';
import { CloseMeterDataComponent } from './compoment/close-meter-data/close-meter-data.component';
import {CloseMeterDataActionBarBehavior} from "./compoment/action-bar/strategy/impl/close-meter-data-action-bar-behavior";
import {UserGuard} from "../service/user-guard.service";

export function actionBarServiceFactory(...operands: ActionBarBehavior[]): ActionBarContext {
  return new ActionBarContext(operands);
}

const ACTIONBAR_PROVIDER: FactoryProvider = {
  provide: ActionBarContext,
  useFactory: actionBarServiceFactory,
  deps: [
    RefreshActionBarBehavior,
    CloseActionBarBehavior,
    NewActionBarBehavior,
    DeleteActionBarBehavior,
    SaveActionBarBehavior,
    ImportCustomerActionBarBehavior,
    ExportMeterDataBehavior,
    ReportActionBarBehavior,
    CloseMeterDataActionBarBehavior
  ]
};

@NgModule({
  declarations: [
    LoaderComponent,
    DefaultLayoutComponent,
    NotificationComponent,
    BodyContentComponent,
    TableCommonComponent,
    ActionBarComponent,
    BodyFilterComponent,
    InputSearchComponent,
    BodyHeaderComponent,
    BoxDataComponent,
    InputTextComponent,
    SelectComponent,
    DatePickerComponent,
    BodyContentListComponent,
    HeaderInfoComponent,
    StatusPipe,
    TabBarComponent,
    ErrorPipe,
    ChartCommonComponent,
    AddNewFormComponent,
    ConfirmationDialogComponent,
    AccordionComponent,
    TextAutoCompleteComponent,
    ImportCustomerComponent,
    ImportCooperativeComponent,
    CloseMeterDataComponent
  ],
  imports: [
    CommonModule,
    ToasterModule,
    RouterModule,
    AppSidebarModule,
    AppHeaderModule,
    AppAsideModule,
    AppFooterModule,
    PerfectScrollbarModule,
    AppBreadcrumbModule.forRoot(),
    DataTablesModule,
    BsDropdownModule.forRoot(),
    FormsModule,
    HttpClientModule,
    ToasterModule,
    ModalModule,
    ReactiveFormsModule,
    DatepickerModule,
    BsDatepickerModule.forRoot(),
    TabsModule.forRoot(),
    SelectModule,
    AngularMultiSelectModule,
    TypeaheadModule.forRoot(),
    TooltipModule.forRoot(),
    ChartsModule,
    FormsModule,
    ReactiveFormsModule,
    AppSidebarModule,
  ],
  exports: [
    LoaderComponent,
    ToasterModule,
    NotificationComponent,
    BodyContentComponent,
    TableCommonComponent,
    ActionBarComponent,
    BodyFilterComponent,
    InputSearchComponent,
    BodyHeaderComponent,
    BoxDataComponent,
    InputTextComponent,
    SelectComponent,
    DatePickerComponent,
    BodyContentListComponent,
    StatusPipe,
    HeaderInfoComponent,
    TabBarComponent,
    ChartCommonComponent,
    AddNewFormComponent,
    FormsModule,
    ReactiveFormsModule,
    AccordionComponent,
    TextAutoCompleteComponent,
  ],
  providers: [
    ToasterService,
    BsModalService,
    BsDatepickerConfig,
    HttpCustomService,
    ActionBarService,
    TabBarService,
    CustomActionEvent,
    ActionBarContext,
    RefreshActionBarBehavior,
    ACTIONBAR_PROVIDER,
    ConvertStatusCodeService,
    CustomerResolver,
    CloseActionBarBehavior,
    NewActionBarBehavior,
    DeleteActionBarBehavior,
    ImportCustomerActionBarBehavior,
    ExportMeterDataBehavior,
    ReportActionBarBehavior,
    CloseMeterDataActionBarBehavior,
    BsModalRef,
    SaveActionBarBehavior,
    AdminGuard,
    CooperativeGuard,
    UserGuard,
    NavDataService
  ],
  entryComponents: [
    AddNewFormComponent,
    ConfirmationDialogComponent,
  ]
})
export class SharedModule { }
